export default __webpack_public_path__ + "static/media/img8.3a3b8e2d.png";